// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3k1Iv","content":"styles_content__3-T33"};